import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '2rem',
    marginRight: '2rem',
    backgroundColor: theme.palette.background.paper,
    padding: '1rem',
  },
  error: {
    fontSize: 70,
    margin: 0,
    marginBottom: '1rem',
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
  },
  message: {
    fontSize: 20,
    marginLeft: '1rem',
    marginTop: '1rem',
    color: theme.palette.text.primary,
  },
  buttonRowContainer: {
    width: '100%',
  },
  buttonRow: {
    marginTop: '2rem',
    marginBottom: '2rem',
    marginLeft: 'auto',
    marginRight: '2rem',
    display: 'block',
  },
}));

export default useStyles;
